import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

const ToastContext = createContext({ notify: () => {} });

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  const notify = useCallback((text, variant = 'success') => {
    const id = `${Date.now()}-${Math.random()}`;
    setToasts((prev) => [...prev, { id, text, variant }]);
  }, []);

  const value = useMemo(() => ({ notify }), [notify]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 11000, position: 'fixed' }}>
        {toasts.map((t) => (
          <Toast
            key={t.id}
            onClose={() => dismiss(t.id)}
            autohide
            delay={t.variant === 'danger' ? 7000 : 4000}
            bg={t.variant}
            role={t.variant === 'danger' ? 'alert' : 'status'}
          >
            <Toast.Body className={t.variant === 'warning' ? 'text-dark' : 'text-white'}>
              <div className="d-flex justify-content-between align-items-start gap-3">
                <span>{t.text}</span>
                <button
                  type="button"
                  className={`btn-close ${t.variant === 'warning' ? '' : 'btn-close-white'}`}
                  aria-label="Schließen"
                  onClick={() => dismiss(t.id)}
                />
              </div>
            </Toast.Body>
          </Toast>
        ))}
      </ToastContainer>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
